/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import ActionCreator from '../action-creator';
import Contract from '../../shared/entities/contract';

interface UpdateContractProps {
    id: string | null;
    contractData: Contract;
}

export const ActionCreators = {
    // For requesting list of contracts
    RequestContracts: new ActionCreator<'RequestContracts', any>(
        'RequestContracts',
    ),
    ReceivedContractsSuccess: new ActionCreator<'ReceivedContractsSuccess', any>(
        'ReceivedContractsSuccess',
    ),
    ReceivedContractsError: new ActionCreator<'ReceivedContractsError', any>(
        'ReceivedContractsError',
    ),
    ClearReceivedContractsError: new ActionCreator<'ClearReceivedContractsError', any>(
        'ClearReceivedContractsError',
    ),

    // For requesting specific contract
    RequestCurrentContract: new ActionCreator<'RequestCurrentContract', string>(
        'RequestCurrentContract',
    ),
    ReceivedCurrentContractSuccess: new ActionCreator<'ReceivedCurrentContractSuccess', any>(
        'ReceivedCurrentContractSuccess',
    ),
    ReceivedCurrentContractError: new ActionCreator<'ReceivedCurrentContractError', any>(
        'ReceivedCurrentContractError',
    ),
    ClearReceivedCurrentContractError: new ActionCreator<'ClearReceivedCurrentContractError', any>(
        'ClearReceivedCurrentContractError',
    ),
    
    // For adding a contract
    ProvisionContract: new ActionCreator<'ProvisionContract', Contract>(
        'ProvisionContract',
    ),
    ContractProvisioningSuccess: new ActionCreator<'ContractProvisioningSuccess', any>(
        'ContractProvisioningSuccess',
    ),
    ContractProvisioningError: new ActionCreator<'ContractProvisioningError', any>(
        'ContractProvisioningError',
    ),
    ClearContractProvisioningError: new ActionCreator<'ClearContractProvisioningError', any>(
        'ClearContractProvisioningError',
    ),

    // For deleting a contract
    DeleteContract: new ActionCreator<'DeleteContract', string>(
        'DeleteContract',
    ),
    DeleteContractSuccess: new ActionCreator<'DeleteContractSuccess', any>(
        'DeleteContractSuccess',
    ),
    DeleteContractError: new ActionCreator<'DeleteContractError', any>(
        'DeleteContractError',
    ),
    ClearDeleteContractError: new ActionCreator<'ClearDeleteContractError', any>(
        'ClearDeleteContractError',
    ),


    // For updating a contract
    UpdateContract: new ActionCreator<'UpdateContract', UpdateContractProps>(
        'UpdateContract',
    ),
    UpdateContractSuccess: new ActionCreator<'UpdateContractSuccess', any>(
        'UpdateContractSuccess',
    ),
    UpdateContractError: new ActionCreator<'UpdateContractError', any>(
        'UpdateContractError',
    ),
    ClearUpdateContractError: new ActionCreator<'ClearUpdateContractError', any>(
        'ClearUpdateContractError',
    ),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function requestContracts() {
    return ActionCreators.RequestContracts.create();
}
export function clearReceivedContractsError() {
    return ActionCreators.ClearReceivedContractsError.create();
}


export function requestCurrentContract(id: string) {
    return ActionCreators.RequestCurrentContract.create(id);
}
export function clearReceivedCurrentContractError() {
    return ActionCreators.ClearReceivedCurrentContractError.create();
}


export function provisionContract(contractData: Contract) {
    return ActionCreators.ProvisionContract.create(contractData);
}
export function clearContractProvisioningError() {
    return ActionCreators.ClearContractProvisioningError.create();
}


export function deleteContract(id: string) {
    return ActionCreators.DeleteContract.create(id);
}
export function clearDeleteContractError() {
    return ActionCreators.ClearDeleteContractError.create();
}


export function updateContract(id: string, contractData: Contract) {
    return ActionCreators.UpdateContract.create({
        id: id,
        contractData: contractData
    });
}
export function clearUpdateContractError() {
    return ActionCreators.ClearUpdateContractError.create();
}